const state = {
  coinMsg: [],
  indexCoinMsg: []
}

const getters = {
  coinMsg: (state) => { return state.coinMsg },
  indexCoinMsg: (state) => { return state.indexCoinMsg }
}

const mutations = {
  changeCoinMsg: (state, params) => {
    state.coinMsg = params
  },
  changeIndexCoinMsg: (state, params) => {
    state.indexCoinMsg = params
  }
}
const actions = {
  changeCoinMsg: ({commit}, params) => {
    commit('changeCoinMsg', params)
  },
  changeIndexCoinMsg: ({commit}, params) => {
    commit('changeIndexCoinMsg', params)
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/index.js